import { GeneralTab } from "./GeneralTab";

export const EsignRuleForm = () => {
  return <GeneralTab />;
};
